<template>
  <div class="postRoadCard">
    <Header></Header>
    <Nav></Nav>
    <Toptitle title="驿道名片"></Toptitle>
    <div class="postRoadCard-map">
      <img :src="yidaoDetail.yidaocard" />
    </div>
    <div class="postRoadCard-introduce">
      <h2 class="postRoadCard-h2">{{yidaoDetail.name}}</h2>
      <!-- <p class="postRoadCard-p">广州从化古道，总长45ｋｍ，现本体遗存有小蛇径古道、上下清幽古道、钱岗古道，总约长5.6ｋｍ，遗存年代为明朝。从20XX
        年开始逐步修复。从化古道沿线有历史建筑32个，自然资源节点4个，特色村4个。</p>
      <h3 class="postRoadCard-h3">风土物产</h3>
      <p class="postRoadCard-p">这里是风土物产的相关介绍</p>
      <h3 class="postRoadCard-h3">气候地质</h3>
      <p class="postRoadCard-p">这里是气候地质的相关介绍</p> -->
      <div class="postRoadCard-content" v-html="yidaoDetail.content"></div>
    </div>
    <div class="postRoadCard-tab">
      <span v-for="(item,index) of yidaoStation" :class="['postRoadCard-tabItem',tip==index?'postRoadCard-tabItem-active':'']"
        :key="index" @click="choiceStation(index,item.id)">{{item.name}}</span>
    </div>
    <div class="postRoadCard-tabContent" v-html="yidaoStationDetail.detailintro">

      <!--      <h3>小蛇径古道</h3>
      <div class="postRoadCard-img">
        <img src="../assets/static/img/icon17.png" />
      </div>
      <ul class="postRoadCard-ul">
        <li>交通指引</li>
        <li>食宿预定</li>
        <li>关键词：古迹与文化</li>
        <li>全长：</li>
        <li>路面情况：</li>
      </ul>
      <div class="postRoadCard-s-imgbox">
        <div class="postRoadCard-img-s">
          <img src="../assets/static/img/icon18.png" />
        </div>
        <div class="postRoadCard-img-s">
          <img src="../assets/static/img/icon19.png" />
        </div>
      </div>
      <ul class="postRoadCard-ul">
        <li>徒步难易程度：</li>
        <li>走完全程所需时间：</li>
        <li>游玩所需时间：</li>
        <li>中途洗手间：</li>
        <li>中途补给：</li>
        <li>可停车位置：</li>
        <li>当地联系电话：</li>
      </ul> -->
    </div>
    <div class="postRoadCard-more">
      <span class="postRoadCard-more-btn" @click="goDestination()">目的地<i class="fa fa-long-arrow-right"></i></span>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        id: '',
        yidaoStation: [],
        yidaoDetail: [],
        yidaoStationDetail: [],
        tip: 0,
        stationID: ''
      }
    },
    components: {
      Header,
      Nav,
      Footer,
      Toptitle
    },
    methods: {
      getYiDaoStation() {
        this.axios.post('api/l_yidaostation/getListByYiDaoId.do', this.qs({
          yidaoid: this.id
        })).then(res => {
          if (res.status == 200) {
            this.yidaoStation = res.data.data
            if (res.data.data.length > 0) {
              this.stationID = res.data.data[0].id
              this.getYiDaoStationDetail()
            }
          }
        })
      },
      getYiDaoDetail() {
        this.axios.post('api/l_yidaoinfo/getDetail.do', this.qs({
          id: this.id
        })).then(res => {
          if (res.status == 200) {
            this.yidaoDetail = res.data.data
          }
        })
      },
      getYiDaoStationDetail() {
        this.axios.post('api/l_yidaostation/getDetail.do', this.qs({
          id: this.stationID
        })).then(res => {
          if (res.status == 200) {
            this.yidaoStationDetail = res.data.data
          }
        })
      },
      choiceStation(index, id) {
        this.tip = index
        this.stationID = id
        this.getYiDaoStationDetail()
      },
      goDestination(){
        console.log(this.id)
        this.$router.push({
          name:'destination',
          query:{
            targetid:this.id
          }
        })
      }
    },
    mounted() {
      this.id = this.$route.query.id
      this.getYiDaoStation()
      this.getYiDaoDetail()
    }
  }
</script>

<style>
</style>
